import { EventType } from "../../../types";

import { AreaMetricsEventCatalog, AreaMetricsEventKeys } from "./area-metrics";
import { CategoriesEventCatalog, CategoriesEventKeys } from "./categories";
import { CReportsEventCatalog, CReportsEventKeys } from "./creports";
import { ImpactEventCatalog, ImpactEventKeys } from "./impact";
import { NeedDetailsEventCatalog, NeedDetailsEventKeys } from "./need-details";
import {
  NeedsAnalyticsEventCatalog,
  NeedsAnalyticsEventKeys,
} from "./needs-analytics";
import { PerformanceEventCatalog, PerformanceEventKeys } from "./performance";
import { TrendsEventCatalog, TrendsEventKeys } from "./trends";
import {
  VolunteerEngagementEventCatalog,
  VolunteerEngagementEventKeys,
} from "./volunteer-engagement";
import {
  VolunteerRecruitmentEventCatalog,
  VolunteerRecruitmentEventKeys,
} from "./volunteer-recruitment";

export const AdminReportsEventKeys = {
  ...AreaMetricsEventKeys,
  ...CategoriesEventKeys,
  ...CReportsEventKeys,
  ...ImpactEventKeys,
  ...NeedsAnalyticsEventKeys,
  ...PerformanceEventKeys,
  ...TrendsEventKeys,
  ...VolunteerEngagementEventKeys,
  ...VolunteerRecruitmentEventKeys,
  ...NeedDetailsEventKeys,
  ADMIN_REPORTS_PAGE_VIEW: "admin-reports-page-view",
} as const;

export const AdminReportsEventCatalog = {
  ...AreaMetricsEventCatalog,
  ...CategoriesEventCatalog,
  ...CReportsEventCatalog,
  ...ImpactEventCatalog,
  ...NeedsAnalyticsEventCatalog,
  ...PerformanceEventCatalog,
  ...TrendsEventCatalog,
  ...VolunteerEngagementEventCatalog,
  ...VolunteerRecruitmentEventCatalog,
  ...NeedDetailsEventCatalog,
  [AdminReportsEventKeys.ADMIN_REPORTS_PAGE_VIEW]: {
    description: "Admin viewed the reports page",
    eventType: EventType.PAGE_VIEW,
    id: 2403,
  },
} as const;
